import { useLocation, useNavigate } from 'react-router-dom-v5-compat';

export const useRemoveQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const removeQueryParams = (paramsToRemove: string[]) => {
    const queryParams = new URLSearchParams(location.search);
    // We don't handle a case where there might be more than one param with this key
    paramsToRemove.forEach((key) => {
      if (queryParams.has(key)) {
        queryParams.delete(key);
      }
    });
    navigate({ search: queryParams.toString() });
  };

  return removeQueryParams;
};
